import React, { Suspense, lazy, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import useMaintenance from '../hooks/useMaintenance';
import { selectMaintenance } from '../slice/selectors';

const MaintenanceModal = lazy(() => import('./MaintenanceModal'));

const SKIP_MAINTENANCE_PAGES = ['/ncb-payment', '/payment-callback'];

const Maintenance: React.FC = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { displayReminder } = useMaintenance();

  const { data: maintenanceData } = useSelector(selectMaintenance);

  useEffect(() => {
    if (
      maintenanceData?.isMaintain &&
      !SKIP_MAINTENANCE_PAGES.includes(pathname)
    ) {
      history.push('/maintenance');
    }
  }, [history, maintenanceData?.isMaintain, pathname]);

  if (!displayReminder) return null;
  return (
    <Suspense>
      <MaintenanceModal />
    </Suspense>
  );
};

export default React.memo(Maintenance);
